
import Component from 'vue-class-component';
import Dataset from '@/shared/data/model/Dataset';
import AutoFlex from './AutoFlex.vue';

@Component
export default class TwoRows1585 extends AutoFlex {
  get autoFlexConfig(): Dataset {
    if (this.slotsNames.length < 2) return {};
    const [slot1, slot2] = this.slotsNames;
    return {
      vertical: true,
      [`${slot1}Basis`]: '22%',
      [`${slot1}Grow`]: '0',
      [`${slot1}Shrink`]: '0',
      [`${slot2}Basis`]: '0',
      [`${slot2}Grow`]: '1',
      [`${slot2}Shrink`]: '0',
    };
  }
}
